import "core-js/modules/es6.string.ends-with";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
export default function (_x) {
  return _ref2.apply(this, arguments);
}

function _ref2() {
  _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(_ref) {
    var redirect, route, store, details, orderIncrementId, viewRoute;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            redirect = _ref.redirect, route = _ref.route, store = _ref.store;

            if (!store.state.orders.subscriptionPaymentFailed) {
              _context.next = 12;
              break;
            }

            details = store.state.orders.failedPaymentOrder;
            orderIncrementId = details.id;
            viewRoute = '/orders/view/' + orderIncrementId;

            if (!route.path.endsWith("/logout")) {
              _context.next = 7;
              break;
            }

            return _context.abrupt("return");

          case 7:
            if (!route.path.endsWith("/login")) {
              _context.next = 9;
              break;
            }

            return _context.abrupt("return");

          case 9:
            if (!route.path.endsWith("/public")) {
              _context.next = 11;
              break;
            }

            return _context.abrupt("return");

          case 11:
            if (!route.path.endsWith(orderIncrementId)) {
              redirect(viewRoute);
            }

          case 12:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _ref2.apply(this, arguments);
}